export type FilterOptionPolarity = 'off' | 'include' | 'exclude';

export function getFilterOptionPolarity(
  id: string,
  includedIds: readonly string[],
  excludedIds: readonly string[]
): FilterOptionPolarity {
  if (includedIds.includes(id)) {
    return 'include';
  }
  if (excludedIds.includes(id)) {
    return 'exclude';
  }
  return 'off';
}

export function cycleFilterOptionPolarity(
  id: string,
  includedIds: readonly string[],
  excludedIds: readonly string[]
): { includedIds: string[]; excludedIds: string[] } {
  const polarity = getFilterOptionPolarity(id, includedIds, excludedIds);
  const withoutIncluded = includedIds.filter((selectedId) => selectedId !== id);
  const withoutExcluded = excludedIds.filter((selectedId) => selectedId !== id);

  if (polarity === 'off') {
    return { includedIds: [...withoutIncluded, id], excludedIds: withoutExcluded };
  }
  if (polarity === 'include') {
    return { includedIds: withoutIncluded, excludedIds: [...withoutExcluded, id] };
  }
  return { includedIds: withoutIncluded, excludedIds: withoutExcluded };
}

export function formatIncludeExcludeCount(includedCount: number, excludedCount: number): string | null {
  if (includedCount === 0 && excludedCount === 0) {
    return null;
  }
  if (excludedCount === 0) {
    return String(includedCount);
  }
  if (includedCount === 0) {
    return `−${excludedCount}`;
  }
  return `+${includedCount} −${excludedCount}`;
}
